export default __webpack_public_path__ + "static/media/Barleys.d93a300b.jpg";